import { Swiper } from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

const propelInit = function() {
const blocks = document.querySelectorAll('.block-archive-post-related');

blocks.forEach((block) => {
	const slider = block.querySelector('.swiper:not(.swiper-initialized)');
	const wrapper = block.querySelector('.swiper-wrapper');

	if (!slider || !wrapper) {
		return;
	}

	const slides = wrapper.children;

	Array.from(slides).forEach((slide) => {
		slide.classList.add('swiper-slide');
	});

	let cardsPerRow = 4;
	let cardsPerRowMobile = 2;

	if (1 === cardsPerRow) {
		cardsPerRowMobile = 1;
	}

	if (block.hasAttribute('data-cards-per-row')) {
		cardsPerRow = parseInt(block.getAttribute('data-cards-per-row'));
	}

	const parentBlock = slider.closest('.acf-block');
	const mobileGap = parentBlock?.dataset?.mobileSliderGap ?? 8;
	const desktopGap = parentBlock?.dataset?.desktopSliderGap ?? 8;

	const settings = {
		loop: false,
		grabCursor: true,
		spaceBetween: mobileGap,
		slidesPerView: 1,
		modules: [A11y, Navigation, Scrollbar],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		breakpoints: {
			576: {
				slidesPerView: cardsPerRowMobile,
				spaceBetween: mobileGap,
			},
			768: {
				spaceBetween: desktopGap,
			},
			992: {
				slidesPerView: cardsPerRow,
				spaceBetween: desktopGap,
			},
		},
		scrollbar: {
			el: slider.parentElement.querySelector('.swiper-scrollbar'),
			draggable: true,
		},
	};

	// Deferred two frames so Swiper reads slide geometry after the browser has
	// painted the swiper-slide class change, rather than forcing a synchronous
	// layout mid-script.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(slider, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['archive-post-related'] = window.propel.blocks['archive-post-related'] || {};
window.propel.blocks['archive-post-related'].script = propelInit;
